/**
 * FogOfWarSettings - Presenter Component (ADR-034)
 *
 * Pure presenter: receives all data and callbacks via props.
 * ZERO store access. ZERO API calls.
 */

import React from 'react';
import { Card, Form, Slider, Switch, Typography } from 'antd';

const { Text } = Typography;

export interface FogOfWarSettingsProps {
  enabled: boolean;
  eraserSize: number;
  onEnabledChange: (enabled: boolean) => void;
  onSizeChange: (size: number) => void;
}

const FogOfWarSettings: React.FC<FogOfWarSettingsProps> = ({
  enabled,
  eraserSize,
  onEnabledChange,
  onSizeChange,
}) => {
  return (
    <Card title="Fog of War Settings" style={{ margin: '16px 0' }}>
      <Form layout="vertical">
        <Form.Item label="Enable Fog of War" valuePropName="checked">
          <Switch
            checked={enabled}
            onChange={onEnabledChange}
          />
        </Form.Item>
        <Form.Item
          label={
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <Text>Eraser Size</Text>
              <Text type="secondary">{eraserSize}px</Text>
            </div>
          }
        >
          <Slider
            min={10}
            max={200}
            step={5}
            value={eraserSize}
            onChange={onSizeChange}
          />
        </Form.Item>
      </Form>
    </Card>
  );
};

export default FogOfWarSettings;